// components
import Autocomplete from '@material-ui/lab/Autocomplete';
import Input from '../Input';

// hooks
import { useAllServicesByCustomer } from 'hooks/services';
import { useEffect, useState } from 'react';
// import { useDivisionValue } from 'providers/DivisionProvider';

import _ from 'lodash';
import { SPACING_LEAST } from 'constants/spacing';
import { Grid } from '@material-ui/core';

/**
 * @component SelectService
 */
function SelectServiceByCustomer({
  value,
  readOnly,
  divisionId,
  selectedService,
  setSelectedService,
  ...rest
}) {
  const [services, setServices] = useState([]);
  const [selectedServiceTitle, setSelectedSeviceTitle] = useState(null);
  const [serviceProviders, setServiceProviders] = useState([]);
  const [selectedDivisionId, setSelectedDivisionId] = useState(null)

  const { mutate, isLoading } = useAllServicesByCustomer(null, null, divisionId);

  const handelProviderSelect = (event, value)=>{
    if(!value){
      return setSelectedService("")
    }
    setSelectedService(value)
  }

  useEffect(() => {
    if (divisionId) {
      setSelectedSeviceTitle(null)
      mutate(
        { dId: divisionId, query: '' },
        {
          onSuccess: (data) => {
            if (data?.status === 'OK') {
              console.log('OK');
              let tempList = data.services.map((service) =>
                service.title.split('/')[0].trim()
              );
              let uniqueServiceList = _.uniq(tempList);
              // setServices(data?.services.map((service)=>({...service, title:service.title.split("/")[0].trim()})));
              setServices(uniqueServiceList);
              setSelectedDivisionId(divisionId)
            }
          },
        }
      );
    } else {
      setServices([]);
    }
  }, [divisionId, mutate]);

  useEffect(() => {
    if (!selectedServiceTitle || !selectedDivisionId){
      setSelectedService("")
      return
    }
    mutate(
      { dId: selectedDivisionId, query: selectedServiceTitle },
      {
        onSuccess: (data) => {
          if (data?.status === 'OK') {
            let filteredServices = data?.services?.filter(service=>service.title.split('/')[0].trim() === selectedServiceTitle)
            if(filteredServices.length === 1){
              setSelectedService(filteredServices[0]);
              return setServiceProviders(filteredServices);
            }
            if (data?.services?.length === 1) {
              setSelectedService(data?.services[0]);
              return setServiceProviders(data?.services);
            }
            let providersList = data.services.map((service) => ({
              ...service,
              provider: service.title.split('/')[1].trim(),
            }));
            // setServices(data?.services.map((service)=>({...service, title:service.title.split("/")[0].trim()})));
            setServiceProviders(providersList);
          }
        }, 
      }
    );
  }, [selectedDivisionId ,selectedServiceTitle, setSelectedService, services, mutate]);

  return (
    <Grid container spacing={SPACING_LEAST}>
      <Grid item xs={12}>
        <Autocomplete
          disablePortal
          filterSelectedOptions
          loading={isLoading}
          noOptionsText="خدمتی برای این بخش وجود ندارد"
          disabled={readOnly}
          getOptionSelected={(option, value) => value === option}
          options={services ? services : []}
          getOptionLabel={(option) => (option ? option : '')}
          renderInput={(params) => <Input label="انتخاب خدمت" {...params} fullWidth />}
          onChange={(event,value) => setSelectedSeviceTitle(value)}
          value={selectedServiceTitle}
          {...rest}
        />
      </Grid>

      {serviceProviders.length > 1 && (
        <Grid item xs={12}>
          <Autocomplete
            disablePortal
            filterSelectedOptions
            loading={isLoading}
            noOptionsText="سرویس دهنده ای برای این بخش وجود ندارد"
            disabled={readOnly}
            getOptionSelected={(option, value) => value?._id === option?._id}
            options={serviceProviders ? serviceProviders : []}
            getOptionLabel={(option) => (option?.provider ? option?.provider : '')}
            onChange={handelProviderSelect}
            renderInput={(params) => (
              <Input label="انتخاب سرویس دهنده" {...params} fullWidth />
            )}
            {...rest}
          />
        </Grid>
      )}
    </Grid>
  );
}

export default SelectServiceByCustomer;
